import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const HistoryPage = lazy(async () => {
  const m = await import("@/features/gym/components/history-page");
  return { default: m.HistoryPage };
});

interface HistorySearch {
  /** Number of sessions displayed ("Load more") — shareable via `?n=`. */
  n?: number;
}

export const historyRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/history",
  validateSearch: (search: Record<string, unknown>): HistorySearch => {
    const n = Number(search.n);
    // Only valid multiples > base page; omit the rest (idempotency).
    return Number.isInteger(n) && n >= 25 ? { n } : {};
  },
  component: () => (
    <Suspense fallback={null}>
      <HistoryPage />
    </Suspense>
  ),
});
